import { MarkdownEditor } from './MarkdownEditor';

interface CommentFormOptions {
  onSubmit: (content: string) => void;
  maxLength: number;
  theme?: 'light' | 'dark';
  placeholder?: string;
}

/**
 * Comment form component - wrapper around MarkdownEditor for creating new comments
 */
export class CommentForm {
  private editor: MarkdownEditor;

  constructor(options: CommentFormOptions) {
    this.editor = new MarkdownEditor({
      onSubmit: options.onSubmit,
      maxLength: options.maxLength,
      theme: options.theme || 'light',
      placeholder: options.placeholder || 'Write a comment...',
      submitLabel: 'Post Comment',
      showCancelButton: false,
      rows: 3,
      className: 'komentas-comment-form'
    });
  }

  public getElement(): HTMLElement {
    return this.editor.getElement();
  }

  public clear(): void {
    this.editor.clear();
  }

  public focus(): void {
    this.editor.focus();
  }

  public setContent(content: string): void {
    this.editor.setContent(content);
  }

  public disable(): void {
    this.editor.disable();
  }

  public enable(): void {
    this.editor.enable();
  }
}
